module.exports = __webpack_public_path__ + "img/img7.7e27af4a.png";